module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "companion-ad-container"
    }
  }, [_c('adsense', {
    attrs: {
      "adtest": "on",
      "ad-client": "ca-pub-4242311851434474",
      "ad-slot": _vm.adSlot,
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba4f65f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/AdContainer.vue
// module id = 404
// module chunks = 1